export interface PrepCountSource {
  total?: unknown
  count?: unknown
}

export const resolveServerTotal = <T>(
  resp: PrepCountSource | null | undefined,
  items?: Array<T> | ReadonlyArray<T> | null,
): number => {
  const rawTotal = resp?.total ?? resp?.count

  if (typeof rawTotal === 'number' && Number.isFinite(rawTotal)) {
    return Math.max(0, Math.floor(rawTotal))
  }

  if (typeof rawTotal === 'string') {
    const parsed = Number.parseInt(rawTotal, 10)
    if (Number.isFinite(parsed)) {
      return Math.max(0, parsed)
    }
  }

  const length = Array.isArray(items) ? items.length : 0
  return length
}

